import {Component, Input} from '@angular/core';

export type BubbleColour = 'orange' | 'red' | 'green' | 'grey';

@Component({
    selector: 'app-bubble',
    templateUrl: './bubble.component.html',
    styleUrls: ['./bubble.component.scss'],
    standalone: true
})
export class BubbleComponent {
  bubbleColor = 'grey';

  @Input() class: string = null;

  @Input() set color(content: BubbleColour) {
    this.bubbleColor = content;
  }

  bubbleSize = 5;

  @Input() set size(content: number) {
    this.bubbleSize = content;
  }
}
